import { render, staticRenderFns } from "./AddCustomerPoint.vue?vue&type=template&id=0610aceb&scoped=true&"
import script from "./AddCustomerPoint.vue?vue&type=script&lang=js&"
export * from "./AddCustomerPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0610aceb",
  null
  
)

export default component.exports